<div class="recent-orders">
    <br />
    <br />
    <div class="table-responsive">
        <div class="form-page-block">
            <div class="card">
                <div class="card-header">
                  <span>Edit Job</span>
                </div>
                <div class="card-body">
                    <div *ngIf="loading; else content" style="text-align: center;">
                        Loading ...
                    </div>
                    <ng-template #content>
                        <form class="form-page" [formGroup]="jobForm" (ngSubmit)="submit()">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="input-field">
                                        <label>Title</label>
                                        <input type="text" class="form-control" formControlName="title" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="input-field">
                                        <label>Job Type</label>
                                        <select class="form-control" formControlName="type">
                                            <option *ngFor="let type of types" [value]="type">{{type}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="input-field">
                                        <label>Location</label>
                                        <input type="text" class="form-control" formControlName="location" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="input-field input-field-checkbox">
                                        <input id="status" type="checkbox" formControlName="status" class="form-check-input" />
                                        <label for="status">Active</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="input-field">
                                        <label>Description</label>
                                        <div class="editor-wrapper">
                                            <quill-editor
                                                formControlName="description"
                                                style="display: block; height: 300px;">
                                            </quill-editor>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-actions">
                                        <button [disabled]="jobForm.invalid || submitting" class="btn btn-success" id="btn-submit" type="submit">
                                            Save
                                        </button>
                                        <span *ngIf="submitting">saving ...</span>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>